module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kj-join"
  }, [_c('ParticipatorList', {
    attrs: {
      "player": _vm.player,
      "id": _vm.id
    },
    on: {
      "isShow": _vm.handleShowchange
    }
  }), _vm._v(" "), _c('yd-popup', {
    attrs: {
      "position": "bottom",
      "height": "auto"
    },
    model: {
      value: (_vm.contentShow),
      callback: function($$v) {
        _vm.contentShow = $$v
      },
      expression: "contentShow"
    }
  }, [_c('div', {
    staticClass: "kj-join-tips"
  }, [_c('button', {
    staticClass: "kj-join-close",
    on: {
      "click": function($event) {
        _vm.contentShow = false
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("./close.svg")
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "kj-join-tips_title"
  }, [_vm._v("活动说明")]), _vm._v(" "), _c('div', {
    staticClass: "kj-join-tips_cont",
    domProps: {
      "innerHTML": _vm._s(_vm.formatTerms)
    }
  })])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6fdb6686","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/base/content/index.vue
// module id = 289
// module chunks = 0